import React from 'react';
import { Star } from 'lucide-react';
import { Card } from './ui/Card';
export function Testimonials() {
  const reviews = [{
    name: 'Sarah M.',
    city: 'Gilbert, AZ',
    rating: 5,
    text: "Absolutely incredible service! My windows haven't looked this clean since we moved in. The team was professional, on time, and super friendly."
  }, {
    name: 'David R.',
    city: 'Scottsdale, AZ',
    rating: 5,
    text: "I've used several window cleaners in the valley, but EZAZ is by far the best. No streaks, fair pricing, and they even cleaned my screens perfectly."
  }, {
    name: 'Jennifer K.',
    city: 'Chandler, AZ',
    rating: 5,
    text: "Highly recommend! They did our two-story home and reached windows I didn't think were possible to clean. Will definitely be booking again."
  }];
  return <section id="reviews" className="py-20 bg-navy-dark" data-id="element-134">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-135">
        <div className="text-center mb-16" data-id="element-136">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-137">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-300" data-id="element-138">
            Don't just take our word for it. See why we're 5-star rated.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-139">
          {reviews.map((review, index) => <Card key={index} className="p-8 bg-white/5 border-white/10 text-white backdrop-blur-sm" data-id="element-140">
              <div className="flex gap-1 mb-4" data-id="element-141">
                {[...Array(review.rating)].map((_, i) => <Star key={i} className="h-5 w-5 fill-gold text-gold" data-id="element-142" />)}
              </div>
              <p className="text-gray-200 mb-6 italic leading-relaxed" data-id="element-143">
                "{review.text}"
              </p>
              <div data-id="element-144">
                <p className="font-bold text-white" data-id="element-145">{review.name}</p>
                <p className="text-sm text-gold" data-id="element-146">{review.city}</p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}